module.exports = __webpack_public_path__ + "img/recovery-card.d6d9ec97.jpg";